<template>
  <div class="handler-warp">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FormFooter',
};
</script>

<style lang="scss" scoped>
.handler-warp {
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 150px;

  button, div {
    margin: 4px;

    ::v-deep span {
      @include pad-width() {
        width: 100%;
      }
      width: 300px;
      white-space: break-spaces;
    }
  }
}
</style>
